import type { FC } from "react";

import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { DEPRECATED_Loading, I18n, useTranslations } from "@jti/ui";

import { useOrder } from "@checkout/hooks/useOrder";

import styles from "./SuccessfulPaymentMessage.module.scss";

const renderDescription = (email: string | undefined) => (
  <I18n t="cart.order.summary.message.description">
    <strong>{email}</strong>
  </I18n>
);

export const SuccessfulPaymentMessage: FC = () => {
  const { __ } = useTranslations();
  const { orderFetchStatus, contactEmail } = useOrder();

  return (
    <div className={styles.container}>
      <h2 className={styles.mainTitle}>{__("cart.order.summary.message.title")}</h2>

      {orderFetchStatus === "pending" && <DEPRECATED_Loading />}

      {orderFetchStatus === "success" && (
        <AlertBanner
          tone="success"
          title={__("cart.order.summary.message.subtitle")}
          description={renderDescription(contactEmail) as any}
        />
      )}
    </div>
  );
};
